import { useQueries } from "@tanstack/react-query";
import { catResults } from "../../../api/routes";
import { CatResultsResponse } from "../../../client/types.gen";

export type BatchLoadStatus = "loading" | "error" | "done";

export interface BatchRun {
  batchId: string;
  // Null until loaded, and after a failed load.
  results: CatResultsResponse | null;
  status: BatchLoadStatus;
}

/** Results of several completed batches, in the order asked for. */
export const useCatBatchResults = (
  reportId: string,
  batchIds: string[]
): BatchRun[] =>
  useQueries({
    queries: batchIds.map((batchId) => ({
      queryKey: ["cat-results", reportId, batchId],
      queryFn: () => catResults(reportId, batchId),
      // A completed batch's results never change.
      staleTime: Infinity,
    })),
    combine: (results) =>
      batchIds.map((batchId, index) => {
        const result = results[index];
        return {
          batchId,
          results: result?.data ?? null,
          status: result?.isError ? "error" : result?.data ? "done" : "loading",
        };
      }),
  });
